import React from 'react';
import '../css/print-progress-bar.css';

const LinearProgressBar = ({ percentage, displayStatus, totalPrintTime = 'Unknown', remainingPrintTime = 'Unknown', isDeskTop = true }) => {
    return (
        <div style={{ width: '100%' }}>
            <div className="print-progress-bar">
                <div className="print-process-content">
                    <div>
                        {isDeskTop && <div>Total</div>}
                        <div style={{ fontWeight: 600 }}>{totalPrintTime}</div>
                    </div>
                    <div style={{ fontWeight: 600 }}>
                        {displayStatus}
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        {isDeskTop && <div>Remaining</div>}
                        <div style={{ fontWeight: 600 }}>{remainingPrintTime}</div>
                    </div>
                </div>
                <div style={{ width: `${percentage}%` }} className={`print-progress print-progress-${displayStatus}`}>
                </div>
            </div>
        </div>
    );
};

export default LinearProgressBar;



// WEBPACK FOOTER //
// ./src/components/print-progress-bar.js